import { Grid, MenuItem,  Button } from "@material-ui/core"
import Paper from "@material-ui/core/Paper"
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from "../../../../hooks/useForm"
import { CboLocalidades } from "../../../cbos/CboLocalidades"
import { CboProvincias } from "../../../cbos/CboProvincias"
// import {ConsultarOferentes} from "../../../../actions/compras/OferentesAction"
import { Save } from "@material-ui/icons"
import { MENU_PROVEEDORES } from "../../../../utils/constants"
import { guardarInformacionProveedor } from "../../../../actions/compras/ProveedoresAction"

export const InformacionProveedor = (props) => {
    const {esNuevo} = props; 
    const {Menu} = props;
    const dispatch = useDispatch();
    const {proveedorInfo} = useSelector((state) => state.proveedores)    
    const {oferente} = useSelector((state) => state.compras)

    const {items:localidades} = useSelector((state) => state.localidades)
    const {rubros, tipoProveedor} = useSelector((state) => state.proveedores)
    console.log(oferente)
    let datosNuevos =  {
        idProveedor: null,
        idTipoProveedor: null,
        razonSocial: oferente.razonSocial,
        nombreFantasia: oferente.nombreFantasia,
        cuit: oferente.cuit,
        idOferente:oferente.idOferente,
        proveedoresDomicilio: {
            calle: "",
            numero: "",
            piso: "",
            depto: "",
            cp: "",
            idLocalidad: null,
            idProvincia: null
        },
        Rubros:null


    };
    
    const [
        formValues, 
        handleInputChange,
        ,
        ,
        ,
        ,
        ,
        ,
        ,
        setearVariosValoresHijos,    
        ] = useForm(esNuevo ? datosNuevos : proveedorInfo);

        const {
            idProveedor,
            idTipoProveedor,
            razonSocial,
            nombreFantasia,
            proveedoresDomicilio: {
                calle,
                numero,
                piso,
                depto,
                cp,
                idLocalidad,
                idProvincia
            },
            Rubros
        } = formValues;


        const handleLocalidad = (e) =>{
            
            if(localidades.length > 0 ){
                const localidad = localidades.find(
                    (loc) => parseInt(loc.id_localidad) === parseInt(e.target.value)
                );
                setearVariosValoresHijos("proveedoresDomicilio",{
                    idLocalidad : localidad?.id_localidad,
                    idProvincia:localidad?.id_provincia
                })
            }
        }


        const handleSubmit = (e) => {
            
            e.preventDefault();
            dispatch(guardarInformacionProveedor(formValues))
        }
    return(
        <>
            <ValidatorForm  onSubmit={handleSubmit}>
                <Grid container spacing={1} component={Paper} style={{padding: "40px"}}>
                <Grid item sm={3}>
                        <TextValidator 
                            margin="normal"
                            fullWidth={true}
                            label="Cod. Proveedor"
                            name="idProveedor"
                            value={idProveedor}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={true}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <SelectValidator
                            margin="normal"
                            fullWidth
                            label="Tipo Proveedor"
                            name="idTipoProveedor"
                            onChange={handleInputChange}
                            value={idTipoProveedor || ""}
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >
                            {
                               tipoProveedor.map((tipo) => (
                                    <MenuItem
                                        key={tipo.idTipoProveedor}
                                        value={tipo.idTipoProveedor}
                                    >
                                        {tipo.descripcion}
                                    </MenuItem>
                                ))
                            }
                        </SelectValidator>
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator 
                            margin="normal"
                            fullWidth={true}
                            label="Razón Social"
                            name="razonSocial"
                            value={razonSocial}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        />
                    </Grid>
                    {/* <Grid item sm={3}>
                        <TextValidator 
                            margin="normal"
                            fullWidth={true}
                            label="CUIT"
                            name="cuit"
                            value={cuit}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            
                        />
                    </Grid> */}
                    <Grid item sm={3}>
                        <TextValidator 
                            margin="normal"
                            fullWidth={true}
                            label="Nombre Fantasia"
                            name="nombreFantasia"
                            value={nombreFantasia}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator 
                            margin="normal"
                            fullWidth={true}
                            label="Calle"
                            name="proveedoresDomicilio.calle"
                            value={calle}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator 
                            margin="normal"
                            fullWidth={true}
                            label="Numero"
                            name="proveedoresDomicilio.numero"
                            onChange={handleInputChange}
                            value={numero}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator 
                            margin="normal"
                            fullWidth={true}
                            label="Piso"
                            name="proveedoresDomicilio.piso"
                            value={piso}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator 
                            margin="normal"
                            fullWidth={true}
                            label="Departamento"
                            name="proveedoresDomicilio.depto"
                            value={depto}
                            onChange={handleInputChange}
                            autoComplete="off"
                            maxLength="13"
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        />
                    </Grid>
                    <Grid item sm={3}>
                        <TextValidator 
                            margin="normal"
                            fullWidth={true}
                            label="Cód. Postal"
                            name="proveedoresDomicilio.cp"
                            value={cp}
                            autoComplete="off"
                            maxLength="13"
                            onChange={handleInputChange}
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        />
                    </Grid>
                    <Grid item sm={3}>
                            <CboLocalidades 
                                cp={cp ? cp : 0}
                                valor={idLocalidad}
                                name='proveedoresDomicilio.idLocalidad'
                                manejadorInputChange={handleLocalidad}
                                disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                            />
                    </Grid>
                    <Grid item sm={3}>
                        <CboProvincias 
                            name='idProvincia'
                            valor={idProvincia}
                            manejadorInputChange={handleInputChange}
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        />
                    </Grid>
                    <Grid item sm={3}>
                    <SelectValidator
                            margin="normal"
                            fullWidth
                            label="Rubros"
                            name="Rubros"
                            onChange={handleInputChange}
                            value={Rubros || ""}
                            disabled={Menu === MENU_PROVEEDORES.CONSULTA}
                        >
                            {
                               rubros.map((rubro) => (
                                    <MenuItem
                                        key={rubro.idRubro}
                                        value={rubro.idRubro}
                                    >
                                        {rubro.descripcion}
                                    </MenuItem>
                                ))
                            }
                        </SelectValidator>
                    </Grid>
                </Grid>

                {
                    Menu === MENU_PROVEEDORES.INGRESO && 
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            color="primary"
                            variant="contained"
                            startIcon={ <Save/> }
                            style={{ marginTop: "1rem" }}
                            type="submit"
                        >
                            Guardar Cambios
                        </Button>
                    </div>
                }

            </ValidatorForm>
        </>
    )
}